import { useFetchCssVars } from 'ContentData/queries/GlobalStylesQuery';
import { useLoadGlobalStylesCssVars } from '../../../hooks/useLoadGlobalStyles';
export const StylesLoader = () => {
  const {
    data
  } = useFetchCssVars({}, {
    bufferTheme: true,
    fetchPolicy: 'cache-and-network'
  });
  useLoadGlobalStylesCssVars(data);
  return null;
};